import React from 'react'

import { ethers } from 'ethers'
import { useEffect, useState } from 'react'
import axios from 'axios'
import Web3Modal from "web3modal"
import {
    nftaddress, nftmarketaddress
} from '../../polygan/config';




import NFT from '../../utils/polygon/NFT.json';
import Market from '../../utils/polygon/NFTMarket.json';





import Countdown from 'react-countdown';

import item1 from '../im/items/featured-item-1.png';
import item2 from '../im/items/featured-item-2.png';
import item3 from '../im/items/featured-item-3.png';
import item4 from '../im/items/featured-item-4.png';
import item5 from '../im/items/featured-item-5.png';
import item6 from '../im/items/featured-item-6.png';
import item7 from '../im/items/featured-item-7.png';
import item8 from '../im/items/featured-item-8.png';
import item9 from '../im/items/featured-item-9.png';
import item10 from '../im/items/featured-item-10.png';
import item11 from '../im/items/featured-item-11.png';
import item12 from '../im/items/featured-item-12.png';
import item13 from '../im/items/featured-item-13.png';
import item14 from '../im/items/featured-item-14.png';
import item15 from '../im/items/featured-item-15.png';
import item16 from '../im/items/featured-item-16.png';

import a1 from "../im/ava.png"


import a2 from '../im/avatarr/avatar-2.png';
import a3 from '../im/avatarr/avatar-3.png';
import a4 from '../im/avatarr/avatar-4.png';
import a5 from '../im/avatarr/avatar-5.png';
import a6 from '../im/avatarr/avatar-6.png';
import a7 from '../im/avatarr/avatar-7.png';
import a8 from '../im/avatarr/avatar-8.png';
import a9 from '../im/avatarr/avatar-9.png';
import a10 from '../im/avatarr/avatar-10.png';
import a11 from '../im/avatarr/avatar-11.png';
import a12 from '../im/avatarr/avatar-12.png';
import a13 from '../im/avatarr/avatar-13.png';
import a14 from '../im/avatarr/avatar-14.png';
import a15 from '../im/avatarr/avatar-15.png';





import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Footerr from '../Footer/Footerr';

function Polysale() {



    const [nfts, setNfts] = useState([])
    const [loadingState, setLoadingState] = useState('not-loaded')
    useEffect(() => {
        loadNFTs()
    }, [])
    async function loadNFTs() {
        /* create a generic provider and query for unsold market items */
        // const provider = new ethers.providers.JsonRpcProvider('https://ropsten.infura.io/v3/c1e1ec09acaf40dead35d6ea8af26736')
        const provider = new ethers.providers.JsonRpcProvider('https://polygon-mumbai.infura.io/v3/66b7f136e09341699d0271ffa9ef18d6')

        // const provider = new ethers.providers.JsonRpcProvider('https://rpc-mumbai.maticvigil.com')

        const tokenContract = new ethers.Contract(nftaddress, NFT.abi, provider)
        const marketContract = new ethers.Contract(nftmarketaddress, Market.abi, provider)
        const data = await marketContract.fetchMarketItems()
    
        /*
        *  map over items returned from smart contract and format 
        *  them as well as fetch their token metadata
        */
        const items = await Promise.all(data.map(async i => {
          const tokenUri = await tokenContract.tokenURI(i.tokenId)
          const meta = await axios.get(tokenUri)
          let price = ethers.utils.formatUnits(i.price.toString(), 'ether')
          let item = {
            price,
            tokenId: i.tokenId.toString(),
    
            seller: i.seller,
            owner: i.owner,
            image: meta.data.image,
            name: meta.data.name,
            description: meta.data.description,
          }
          return item
        }))
        setNfts(items)
        setLoadingState('loaded')
      }
      async function buyNft(nft) {
        /* needs the user to sign the transaction, so will use Web3Provider and sign it */
        const web3Modal = new Web3Modal()
        const connection = await web3Modal.connect()
        const provider = new ethers.providers.Web3Provider(connection)
        const signer = provider.getSigner()
        const contract = new ethers.Contract(nftmarketaddress, Market.abi, signer)
    
        /* user will be prompted to pay the asking proces to complete the transaction */
        const price = ethers.utils.parseUnits(nft.price.toString(), 'ether')
        const transaction = await contract.createMarketSale(nftaddress, nft.tokenId, {
          value: price
        })
        await transaction.wait()
        loadNFTs()
      }
    if (loadingState === 'loaded' && !nfts.length) return (<h1 className="px-20 py-10 text-3xl">No items in marketplace</h1>)









    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 10
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 8
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 3
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };
    return (
        <div>


            <div className=' '>




                <div className='mx-5 mt-5 '>

                    <h1 class="fw-bold  text-capitalize text-light display-5"><span className='headtextt'>Explore</span > Artworks in <span className='headtextt'>polygan network</span></h1>




                </div>

                <div className='p-5'>
                    <Carousel responsive={responsive} >





                        <div className='p-1'><button className='p-2  text-light button  rounded-9 btn-block'> <span class="emoji">&#11088; All items</span></button>


                        </div>

                        <div className='p-1'><button className='p-2  text-light button  rounded-9 btn-block'> <span class="emoji">&#128142; Featured</span></button>


                        </div>


                        <div className='p-1'><button className='p-2  text-light button  rounded-9 btn-block'> <span class="emoji">&#128142;</span> 3d Artwor</button>


                        </div>

                        <div className='p-1'><button className='p-2  text-light button  rounded-9 btn-block '> <span class="emoji">&#127750;</span>illustrations</button>


                        </div>

                        <div className='p-1'><button className='p-2  text-light button  rounded-9 btn-block '> <span class="emoji">&#127918;</span>Gaming</button>


                        </div>




                        <div className='p-1'><button className='p-2  text-light button  rounded-9   btn-block'><span class="emoji">&#128247;</span> photography</button>


                        </div>

                        <div className='p-1'><button className=' p-2  text-light button  rounded-9   btn-block'><span class="emoji">&#9830;</span> MotionGraphics</button>


                        </div>

                        <div className='p-1'><button className='p-2  text-light button  rounded-9   btn-block'><span class="emoji">&#128163;</span> pop culture</button>


                        </div>

                        <div className='p-1'><button className=' p-2  text-light button  rounded-9   btn-block'><span class="emoji">&#128516;</span> Memes</button>


                        </div>
                        <div className='p-1'><button className='p-2  text-light button  rounded-9   btn-block'><span class="emoji">&#128691;</span> NFSF</button>


                        </div>

                        <div className='p-1'><button className=' p-2  text-light button  rounded-9   btn-block'><span class="emoji">&#129309;</span> Looping artwork</button>


                        </div>



































                    </Carousel>

                </div>

                <div className='mx-5 '>
                    <div className='col-lg-12 border border-dark rounded-9  p-4'>
                        <div className='row'>
                            <div className='col-lg-2'>


                                <div class=" ">

                                    <select class="custom-select  btn  button  rounded-9 text-light fw-bolder bg-dark col-lg-12" id="inputGroupSelect03">

                                        <option selected value="1">Newest to Oldes</option>
                                        <option value="oldest-to-newest">Oldest to Newest</option>
                                        <option value="3">Most Popular</option>

                                    </select>
                                </div>

                            </div>

                            <div className='col-lg-2'>


                                <div class=" ">

                                    <select class="custom-select  btn  button  rounded-9 text-light fw-bolder bg-dark border col-lg-12" id="inputGroupSelect03">

                                        <option selected value="Auctions Only">Auctions Only</option>
                                        <option value="Buy Now">Buy Now</option>
                                        <option value="all-artworks">All Artworks</option>

                                    </select>
                                </div>

                            </div>

                            <div className='col-lg-2'>


                                <div class=" ">

                                    <select class="custom-select  btn  button  rounded-9 text-light fw-bolder bg-dark  col-lg-12" id="inputGroupSelect03">

                                        <option value="verified-creators" selected>Verified Creators</option>
                                        <option value="all-creators">All Creators</option>
                                    </select>
                                </div>

                            </div>

                            <div className='col-lg-2'>


                                <div class=" ">

                                    <select class="custom-select  btn  button  rounded-9 text-light fw-bolder bg-dark col-lg-12" id="inputGroupSelect03">
                                        <option value="ending-soon" selected>Ending Soon</option>
                                        <option value="anytime">Anytime</option>

                                    </select>
                                </div>

                            </div>

                            <div className='col-lg-2'>


                                <div class=" ">

                                    <select class="custom-select  btn  button  rounded-9 text-light fw-bolder bg-dark col-lg-12" id="inputGroupSelect03">

                                        <option value="lowest-to-highest" selected>Lowest to Highest $</option>
                                        <option value="highest-to-lowest">Highest to Lowest $</option>

                                    </select>
                                </div>

                            </div>



                            <div className='col-lg-2'>
                                <button type="submit" className="  col-lg-8  text-light rounded-9 btn myButton1">Filter</button>
                            </div>



                        </div>






                    </div>
                </div>











            </div>

            {/* cards */}


            <div>

                {/* cards start here */}
                <div className='p-4'>


                    {
                        nfts.map((nft, i) => (


                            <div className=' col-lg-3 col-sm-1 col-md-6 d-inline-block p-3 ' >

                                <div className=''>

                                    <div className=' bg-dark  border border-muted rounded-9 '>


                                        <div className='card    rounded-9 bggtimer '>
                                            <div className='card   border border-muted rounded-9 bggtimer'>

                                                <img src={nft.image} className='rounded-9 p-3  ch'></img>

                                                <div className='bg-dark col-sm-12 col-lg-6 col-md-8 mx-auto rounded-9 car-tim  hover-overlay  border border-muted'>
                                                    <a ><h6 className='my-auto  text-light '> <i class="fas fa-clock p-2"></i> <Countdown date={Date.now() + 550000000}></Countdown></h6></a>

                                                    <div class="mask  rounded-9 bgbtt-gra">
                                                        <a ><h6 className='my-auto  text-light'><i class="fas fa-clock p-2"></i><Countdown date={Date.now() + 550000000}></Countdown></h6></a>

                                                    </div>
                                                </div>


                                                <h5 className=' fw-bolder mx-3 text-light'>{nft.name}</h5>
                                                <p className=' fw-bolder mx-3 text-light'>{nft.description}</p>



                                                {/* if you want to show current owner show that */}


                                                {/* <p className=' fw-bolder mx-3 text-light'>owner: <span className='tx-sm'>{nft.owner}</span></p> */}
                                                <p className=' fw-bolder mx-3 text-light'>seller: <span className='tx-sm'>{nft.seller}</span></p>

                                            </div>
                                            <span class="badge rounded-pill badge-notification bg-dark mt-3  p-3 align-self-end  hover-overlay border border-muted" > <i class="fas fa-heart"></i>  60 </span>

                                        </div>
                                        <div className='container'>
                                            <div className='row mt-3 fw-bold text-light'>
                                                <div className='col-6'>
                                                    <h6>RESERVE PRICE</h6>
                                                    <h5>{nft.price}</h5>

                                                </div>
                                                <div className='col-6'>
                                                    <h6>SHARE</h6>
                                                    <h6><i class="fab fa-facebook-square "><i class="fab fa-twitter mx-3"></i></i><i class="fab fa-instagram"></i></h6>

                                                </div>

                                            </div>

                                            <div className='mx-auto p-1'>
                                                <button className="btn btn-danger col-12 " onClick={() => buyNft(nft)}>Buy</button>
                                            </div>

                                        </div>










                                    </div>

                                </div>
                            </div>))
                    }
                </div>


                <div class=" text-center fw-bolder">



                    <a href='' className='mx-2'>01</a>
                    <a href='' className='mx-2'>02</a>
                    <a href='' className='mx-2'>03</a>
                    <a href='' className='mx-2'>04</a>
                    <a href='' className='mx-2'>...</a>
                    <a href='' className='mx-2'>16</a>
                    <a href='' className='mx-2'>Next</a>


                </div>

                <div>

                </div>

            </div>


            <div className='my-5'>



                <Footerr />

            </div>

        </div>
    )
}

export default Polysale
